/**
 * A quick sideways flick across the reader's page, which turns it. Dragging
 * across words to translate a phrase is slower and more deliberate, so a
 * touch only counts as a swipe if it's over quickly, goes far enough, and goes
 * mostly sideways.
 */

/** How long a touch may be a swipe for */
export const maxMilliseconds = 300;
const minDistancePixels = 50;

export type SwipeDirection = "left" | "right";

type Point = { clientX: number; clientY: number };

export class PageSwipe {
  private start?: Point & { time: number };

  /** On a touch starting: one finger may be a swipe, more never are */
  begin(touches: ArrayLike<Point>, time: number) {
    this.start =
      touches.length === 1
        ? { clientX: touches[0].clientX, clientY: touches[0].clientY, time }
        : undefined;
  }

  /** On the touch ending: the way it swiped, if it was a swipe */
  end(touch: Point, time: number): SwipeDirection | undefined {
    const start = this.start;
    this.start = undefined;
    if (!start || time - start.time > maxMilliseconds) {
      return undefined;
    }
    const deltaX = touch.clientX - start.clientX;
    const deltaY = touch.clientY - start.clientY;
    if (
      Math.abs(deltaX) < minDistancePixels ||
      Math.abs(deltaY) > Math.abs(deltaX) / 2
    ) {
      return undefined;
    }
    return deltaX < 0 ? "left" : "right";
  }
}
